'use client';

import { Button, Drawer, Grid, Heading, TextPassage } from '@petsmart-ui/sparky';
import { useFormikContext } from 'formik';

import { AccountDrawerType, usePageLayout } from '@libs/common-next';

import type { ForgotPasswordForm } from '../ForgotPasswordDrawer/type';
import type { ResetPasswordConfirmationDrawerProps } from './type';
import './ResetPasswordConfirmationDrawer.scss';

export function ResetPasswordConfirmationDrawer({ email }: ResetPasswordConfirmationDrawerProps) {
    const { accountDrawersOpen, removeAccountDrawers } = usePageLayout();
    const { resetForm } = useFormikContext<ForgotPasswordForm>();

    return (
        <Drawer
            data-testid="password-confirmation-drawer"
            align="right"
            isActive={accountDrawersOpen?.includes(AccountDrawerType.RESET_PASSWORD_CONFIRMATION)}
            onClose={() => {
                removeAccountDrawers([
                    AccountDrawerType.SIGN_IN,
                    AccountDrawerType.FORGOT_PASSWORD,
                    AccountDrawerType.RESET_PASSWORD_CONFIRMATION,
                ]);
                resetForm();
            }}
            ariaLabelledBy="drawer-heading-1"
            className="password-confirmation-drawer"
        >
            <Drawer.Header>
                <Heading
                    data-testid="password-confirmation-drawer-heading-1"
                    id="drawer-heading-1"
                    tagName="h2"
                    size="title"
                >
                    Reset password
                </Heading>
            </Drawer.Header>
            <Drawer.Body>
                <Grid>
                    <Grid.Item>
                        <TextPassage>
                            {`We will send an email to `}
                            <span className="sparky-u-theme-typography-body-bold">{email}</span>
                            {` to reset your password.`}
                        </TextPassage>
                    </Grid.Item>
                    <Grid.Item>
                        <TextPassage>
                            {`If you don't receive this email, check your spam
                            folder.`}
                        </TextPassage>
                    </Grid.Item>
                    <Grid.Item>
                        <Button
                            data-testid="got-it-btn"
                            fullWidth
                            text="Got it"
                            size="lg"
                            variant="primary"
                            onClick={() => {
                                removeAccountDrawers([
                                    AccountDrawerType.SIGN_IN,
                                    AccountDrawerType.FORGOT_PASSWORD,
                                    AccountDrawerType.RESET_PASSWORD_CONFIRMATION,
                                ]);
                                resetForm();
                            }}
                        />
                    </Grid.Item>
                </Grid>
            </Drawer.Body>
        </Drawer>
    );
}
